import { WidgetFacts, WidgetType } from '@shared/enums';
import { WidgetDetail } from '@shared/models';

export const widgetFacts = [WidgetFacts.Percentage, WidgetFacts.Employees, WidgetFacts.Jobs];
export const readyOrWhenWidgets = [
  WidgetType.FormW2Soon,
  WidgetType.Form1099Soon,
  WidgetType.FormW2When,
  WidgetType.Form1099When,
];
export const noWidget = { type: WidgetType.None };

export const buildWidget = (widgetConfig: WidgetDetail): WidgetDetail => {
  return widgetConfig.type ? widgetConfig : noWidget;
};
